// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://okokjpcuxksmlteljqmn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9rb2tqcGN1eGtzbWx0ZWxqcW1uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1Njk4NTQsImV4cCI6MjA2MTE0NTg1NH0.SknCHRwDSkEv-3xL8DgVd2RkaHQm2OhN2WEcC_3eNfc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);